export type BadgePaletteSlot =
  | "info"
  | "success"
  | "warning"
  | "secondary"
  | "neutral";

export interface BadgeStyle {
  paletteSlot: BadgePaletteSlot;
  variant: "filled" | "outlined";
  fontVariant: "body3" | "overline2";
}

export interface TimelineArticle {
  id: string;
  categoryLabel: string;
  badge: BadgeStyle;
  title: string;
  description?: string;
  recommendation?: string;
  price?: number;
  isin?: string;
  country?: string;
  logoUrl?: string;
  href?: string;
}

export const CATEGORY_BADGES: Record<string, BadgeStyle> = {
  "Wichtige News": {
    paletteSlot: "info",
    variant: "filled",
    fontVariant: "overline2",
  },
  Unternehmensmeldung: {
    paletteSlot: "info",
    variant: "filled",
    fontVariant: "overline2",
  },
  "Adhoc-Meldung": {
    paletteSlot: "info",
    variant: "filled",
    fontVariant: "overline2",
  },
  Bewertung: {
    paletteSlot: "success",
    variant: "filled",
    fontVariant: "overline2",
  },
  "Ex-Dividende": {
    paletteSlot: "info",
    variant: "outlined",
    fontVariant: "overline2",
  },
  Dividendenzahlung: {
    paletteSlot: "info",
    variant: "outlined",
    fontVariant: "body3",
  },
  Quartalszahlen: {
    paletteSlot: "info",
    variant: "filled",
    fontVariant: "overline2",
  },
};

export const DEFAULT_BADGE: BadgeStyle = {
  paletteSlot: "neutral",
  variant: "filled",
  fontVariant: "overline2",
};
